import { Component, EventEmitter } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { InstructorRepositoryService, InstructorStudentLinkResult } from '../../services/instructor-repository.service';

@Component({
  selector: 'app-add-student-by-code-modal',
  templateUrl: './add-student-by-code-modal.component.html',
  styleUrls: ['./add-student-by-code-modal.component.scss']
})
export class AddStudentByCodeModalComponent implements DwModalHandler {
  modalConfig: DwModalConfig<any>;
  closeModal = new EventEmitter<DwModalResult<InstructorStudentLinkResult>>();

  studentCode = '';
  errorMessage = '';
  submitting = false;

  constructor(private instructorRepositoryService: InstructorRepositoryService) { }

  studentCodeChanged(value: string): void {
    const normalized = (value || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 6);
    this.studentCode = normalized.length > 3
      ? `${normalized.slice(0, 3)}-${normalized.slice(3)}`
      : normalized;
    this.errorMessage = '';
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<InstructorStudentLinkResult>> {
    const modalResult = new DwModalResult<InstructorStudentLinkResult>();

    if (buttonConfig.command === DwButtonCommand.cancel) {
      modalResult.closeModal = true;
      modalResult.cancelled = true;
      return of(modalResult);
    }

    if (!/^[A-Z]{3}-[A-Z]{3}$/.test(this.studentCode)) {
      this.errorMessage = 'Enter a valid training code in the format ABC-DEF.';
      return of(modalResult);
    }

    this.submitting = true;

    return this.instructorRepositoryService.linkStudentByCode(this.studentCode)
      .pipe(
        map(result => {
          this.submitting = false;

          if (!result.IsSuccess) {
            this.errorMessage = result.ErrorMessage || 'The student could not be added.';
            return modalResult;
          }

          modalResult.data = result;
          modalResult.closeModal = true;
          return modalResult;
        }),
        catchError(() => {
          this.submitting = false;
          this.errorMessage = 'The student could not be added. Please try again.';
          return of(modalResult);
        })
      );
  }
}
